import React from 'react';
import { Exchange } from '@saleshandy/icons';

const PrimaryEmailNumberExchange = () => (
  <Exchange className='blue-txt-11' />
);  

export default PrimaryEmailNumberExchange;
